import React from 'react';
import { useTranslation } from 'react-i18next';
import { DsEthAvatar, DsExplorerLink } from '@tokenyico/design-system/dist/reactJS';

const RequestInfoByType = ({ request, token, requestInfoByType }) => {
  const { t } = useTranslation();

  if (!requestInfoByType) return null;

  if (request.type === 'CONDITIONAL_TRANSFER') {
    return (
      <>
        <div
          className="_grid _col(12) _nogutter _p(2)"
          style={{ borderBottom: '1px solid var(--grey-500)' }}
        >
          <div className="_col(12) _col:md(4) _text:xs _text-grey-900">{t('shared.sender')}</div>
          <div className="_col(12) _col:md(8)">
            <div className="_flex:row _flex:align(center) _m:bottom(2)">
              <DsEthAvatar address={request.params.senderWallet} size={14} />
              <span className="_m:x(2)">
                {request.requester} ({t('shared.me')})
              </span>
            </div>
            <DsExplorerLink
              isTokenTransfer
              network={token.blockchainNetwork}
              address={request.params.senderWallet}
              type="wallet"
            />
          </div>
        </div>

        <div
          className="_grid _col(12) _nogutter _p(2)"
          style={{ borderBottom: '1px solid var(--grey-500)' }}
        >
          <div className="_col(12) _col:md(4) _text:xs _text-grey-900">{t('shared.recipient')}</div>
          <div className="_col(12) _col:md(8)">
            <div className="_flex:row _flex:align(center) _m:bottom(2)">
              <DsEthAvatar address={request.params.recipientWallet} size={14} />
              <span className="_m:x(2)">{requestInfoByType.recipient}</span>
            </div>
            <DsExplorerLink
              isTokenTransfer
              network={token.blockchainNetwork}
              address={request.params.recipientWallet}
              type="wallet"
            />
          </div>
        </div>

        <div
          className="_grid _col(12) _nogutter _p(2)"
          style={{ borderBottom: '1px solid var(--grey-500)' }}
        >
          <div className="_col(12) _col:md(4) _text:xs _text-grey-900">{t('shared.amount')}</div>
          <div className="_col(12) _col:md(8)">
            {request.params.amount} <span className="">{token.symbol}</span>
          </div>
        </div>
      </>
    );
  }
  if (request.type === 'TOKEN_RECOVERY') {
    return <div></div>;
  }

  if (request.type === 'WHITELIST') {
    return <div></div>;
  }

  return <></>;
};

export default RequestInfoByType;
